import { hasRfxSubmissionDeadlinePassed } from "components/RFQ/SubmissionDeadline/SubmissionDeadline";
import {
	rfxSubmission,
	RfxSubmissionStatus,
} from "newui/features/Rfx/Submission";
import { Rfx, RfxApprover } from "newui/features/Rfx/types/rfx.types";
import { RFX_TABS } from "utils/constants";

export const isRfxApproved = (rfx: Rfx): boolean => {
	if (!rfx) {
		return false;
	}

	if (!rfx?.rfxApprovers || rfx?.rfxApprovers?.length === 0) {
		return true;
	}

	const approvedBy = getRfxApprover(rfx);
	return approvedBy !== undefined;
};

export const doesSubmissionStatusMatch = (
	submissionStatus: string,
	matchTo: RfxSubmissionStatus | RfxSubmissionStatus[]
): boolean => {
	return Array.isArray(matchTo)
		? matchTo.includes(submissionStatus?.toUpperCase())
		: matchTo === submissionStatus.toUpperCase();
};

export const hasInviteeAcceptedRfx = (submissionStatus: string): boolean => {
	return doesSubmissionStatusMatch(
		submissionStatus,
		rfxSubmission.constants.HAS_ACCEPTED
	);
};

export const hasInviteeSubmittedRfx = (submissionStatus: string): boolean => {
	return doesSubmissionStatusMatch(
		submissionStatus,
		rfxSubmission.constants.HAS_SUBMITTED
	);
};

export const getRfxApprover = (rfx: Rfx): RfxApprover | null => {
	return rfx?.rfxApprovers?.find((rfxApprover) => {
		return rfxApprover.hasApproved === true;
	});
};

export const doesRFxHaveApprovers = (rfx: Rfx): boolean => {
	return rfx?.rfxApprovers?.length > 0;
};

export const canViewCurrentTab = (currentTabId: string) => {
	const allowedTabsAfterClose = [
		RFX_TABS.DOCUMENTATION,
		RFX_TABS.COMMS,
		RFX_TABS.ADDENDUMS,
		RFX_TABS.CLARIFICATIONS,
	];
	return allowedTabsAfterClose.includes(currentTabId?.toLowerCase());
};

export const isBeingRevised = (status: string): boolean => {
	return doesSubmissionStatusMatch(
		status,
		rfxSubmission.constants.RFX_SUBMISSION_STATUS.BEING_REVISED
	);
};

export const canEditRfxResponse = (
	isLoading: boolean,
	rfqDetail: Rfx,
	submissionStatus: string
): boolean => {
	if (isLoading) {
		return false;
	}

	// BEING_REVISED status allows editing regardless of deadline
	if (isBeingRevised(submissionStatus)) {
		return true;
	}

	const hasDeadlinePassed = hasRfxSubmissionDeadlinePassed(rfqDetail);
	const hasAccepted = hasInviteeAcceptedRfx(submissionStatus);
	const hasSubmitted = hasInviteeSubmittedRfx(submissionStatus);

	if (!hasDeadlinePassed && hasAccepted && !hasSubmitted) {
		return true;
	}

	if (hasDeadlinePassed || hasSubmitted) {
		return false;
	}

	return false;
};
